// extracted by mini-css-extract-plugin
export default {"icon_info":"IconInfo_icon_info__IQbPg","icon":"IconInfo_icon__CEOLw","title":"IconInfo_title__7RnK0","info":"IconInfo_info__AXEcq"};